import { render } from "./index.vue?vue&type=template&id=70737d68&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=70737d68&scoped=true&lang=css"

import exportComponent from "/Users/jifuzhang/Vue/mindless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70737d68"]])

export default __exports__